import config from 'Cloud/config';
import { addPromoToShowQueue } from 'reactApp/modules/promo/promo.module';
import { EPromoType } from 'reactApp/modules/promo/promo.types';
import { UserSelectors } from 'reactApp/modules/user/user.selectors';
import { sendGa } from 'reactApp/utils/ga';
import { put, select } from 'redux-saga/effects';

const WHATS_NEW_PROMO_CONFIG = config.get('WHATS_NEW_PROMO');
const BANNER_ID = WHATS_NEW_PROMO_CONFIG && WHATS_NEW_PROMO_CONFIG.id;
const banner = BANNER_ID ?? null;

const sendPixel = (pixelType: 'show_pixel' | 'click_pixel' | 'close_pixel') => {
    new Image().src = WHATS_NEW_PROMO_CONFIG[pixelType];
};

const onBannerClose = () => {
    sendPixel('close_pixel');
    sendPromoGa('close');
};

const onBannerClick = () => {
    sendPixel('click_pixel');
    sendPromoGa('primclick');
};

const onSecondary = () => {
    sendPixel('click_pixel');
    sendPromoGa('secclick');
};

const onBannerShow = () => {
    sendPixel('show_pixel');
    sendPromoGa('show');
};

const sendPromoGa = (action: string): void => {
    sendGa('whatsnew-promo', action, BANNER_ID);
};

export function* initWhatsNewPromo(priority: number) {
    if (!banner) {
        return;
    }

    const isNewbie = yield select(UserSelectors.isNewbie);

    if (isNewbie) {
        return;
    }

    yield put(
        addPromoToShowQueue({
            priority,
            type: EPromoType.whatsNew,
            data: {
                onShow: onBannerShow,
                onClose: onBannerClose,
                onClick: onBannerClick,
                onSecondary,
                promoId: BANNER_ID,
                primaryButtonText: WHATS_NEW_PROMO_CONFIG.mainbtntext,
                primaryButtonHref: WHATS_NEW_PROMO_CONFIG.mainbttnlink,
                secondaryButtonText: WHATS_NEW_PROMO_CONFIG.optbttntext,
                secondaryButtonHref: WHATS_NEW_PROMO_CONFIG.optbttnlink,
                title: WHATS_NEW_PROMO_CONFIG.title,
                text: WHATS_NEW_PROMO_CONFIG.description,
                date: WHATS_NEW_PROMO_CONFIG.date,
                imageUrl: WHATS_NEW_PROMO_CONFIG.image,
            },
        })
    );
}
